export default class Form {

    label() {
     
       //On input focus move the label
          $("input, textarea").focus(function() { 
            $(this).parent().siblings("label").addClass("move");
        });

        //On focusout check if there is a value, else remove the .move class.
        $("input, textarea").focusout(function() { 
        if ($(this).val().length == 0) {
            $(this).parent().siblings("label").removeClass("move");
        }
        });

        //In case there is a prefill value
        $("input, textarea").each(function() {
          if ($(this).val().length != 0) { 
              $(this).parent().siblings("label").addClass("move");
          } 
          else {
              $(this).parent().siblings("label").removeClass("move");
          }
        });

    }


    file() {
      $(document).on('change', 'input[type="file"]', function() {
        var file = $(this)[0].files[0].name;
        $(this).parents('.form-field-file').find('.form-field-file__name').text(file);
      });
    }

  
    init() {
      document.querySelector('.wpcf7 ') ? this.label() : null;
      document.querySelector('.form-field-file ') ? this.file() : null;
    }
}
